/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_Reason_Not_FoundInputs */



/**
* | output |
* | --- |
* | "no member found by VEKN ID or email" |
*
* @param {Csv_Import_Reason_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_reason_not_found = /** @type {((inputs?: Csv_Import_Reason_Not_FoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_Reason_Not_FoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("aucun membre trouvé par VEKN ID ou email")
	if (locale === "es") return /** @type {LocalizedString} */ ("ningún miembro encontrado por ID VEKN o correo electrónico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("nenhum membro encontrado por ID VEKN ou e-mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("nessun membro trovato per VEKN ID o email")
	return /** @type {LocalizedString} */ ("no member found by VEKN ID or email")
});